export const STATUS_ELIGIBLE = 'ELIGIBLE' as const;
export const STATUS_INELIGIBLE = 'INELIGIBLE' as const;

export const REASON_INVALID_SLOT_TYPE = 'INVALID_SLOT_TYPE' as const;
export const REASON_NO_SUGGESTIONS = 'NO_SUGGESTIONS' as const;
